import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const Home = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(180deg, #bf0a30 0%, #dc143c 40%, #ff6b6b 60%, #ffffff 100%)',
      padding: '20px',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Stars decoration */}
      <div style={{ position: 'absolute', top: '20px', left: '30px', fontSize: '40px', color: '#bf0a30', opacity: '0.8' }}>★</div>
      <div style={{ position: 'absolute', top: '60px', left: '80px', fontSize: '25px', color: '#ffffff', opacity: '0.6' }}>★</div>
      <div style={{ position: 'absolute', top: '30px', right: '50px', fontSize: '35px', color: '#bf0a30', opacity: '0.7' }}>★</div>
      <div style={{ position: 'absolute', top: '80px', right: '100px', fontSize: '20px', color: '#ffffff', opacity: '0.5' }}>★</div>

      {/* Cola wave decoration */}
      <div style={{
        position: 'absolute',
        bottom: '0',
        left: '0',
        right: '0',
        height: '8px',
        background: 'linear-gradient(90deg, #1a1a1a 0%, #3d1c0f 25%, #5c2e0e 50%, #3d1c0f 75%, #1a1a1a 100%)'
      }}></div>

      {/* Main Card */}
      <div style={{
        background: '#ffffff',
        borderRadius: '25px',
        padding: '50px 60px',
        boxShadow: '0 25px 70px rgba(0, 0, 0, 0.5)',
        border: '5px solid #1a1a1a',
        position: 'relative',
        zIndex: '1',
        maxWidth: '500px',
        width: '100%'
      }}>
        {/* Stars on card */}
        <div style={{ position: 'absolute', top: '-18px', left: '50%', transform: 'translateX(-50%)', display: 'flex', gap: '12px' }}>
          <span style={{ fontSize: '35px', color: '#bf0a30' }}>★</span>
          <span style={{ fontSize: '35px', color: '#3d1c0f' }}>★</span>
          <span style={{ fontSize: '35px', color: '#bf0a30' }}>★</span>
        </div>

        {/* Cola stripe */}
        <div style={{
          position: 'absolute',
          top: '0',
          left: '0',
          right: '0',
          height: '6px',
          background: 'linear-gradient(90deg, #1a1a1a 0%, #3d1c0f 50%, #bf0a30 100%)',
          borderRadius: '20px 20px 0 0'
        }}></div>

        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: '40px', marginTop: '20px' }}>
          <img
            src="/logo.png"
            alt="American Cola"
            style={{
              width: '150px',
              height: 'auto',
              marginBottom: '20px',
              filter: 'drop-shadow(0 6px 20px rgba(61, 28, 15, 0.5))'
            }}
          />
          <h1 style={{
            color: '#1a1a1a',
            fontSize: '36px',
            fontWeight: 'bold',
            margin: '15px 0',
            textTransform: 'uppercase',
            letterSpacing: '3px'
          }}>
            ★ AMERICAN COLA ★
          </h1>
          <p style={{
            color: '#3d1c0f',
            fontSize: '18px',
            fontWeight: 'bold',
            textTransform: 'uppercase',
            letterSpacing: '4px'
          }}>
            CARTE À GRATTER
          </p>
        </div>

        {/* User info */}
        {user && (
          <div style={{
            background: 'linear-gradient(135deg, #fffaf0 0%, #ffffff 100%)',
            borderRadius: '15px',
            padding: '20px 30px',
            marginBottom: '30px',
            border: '3px solid #3d1c0f',
            boxShadow: '0 4px 15px rgba(61, 28, 15, 0.15)'
          }}>
            <p style={{ margin: '0', fontSize: '16px', color: '#1a1a1a', fontWeight: 'bold' }}>
              Connecté en tant que : <span style={{ color: '#bf0a30' }}>{user.username}</span>
            </p>
            <p style={{ margin: '5px 0 0', fontSize: '14px', color: '#3d1c0f' }}>
              Rôle : <strong style={{ color: '#1a1a1a' }}>{user.role}</strong>
            </p>
          </div>
        )}

        {/* Actions */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
          {user?.role === 'super_admin' || user?.role === 'admin' ? (
            <button
              onClick={() => navigate('/dashboard')}
              style={{
                background: 'linear-gradient(180deg, #1a1a1a 0%, #3d1c0f 50%, #1a1a1a 100%)',
                border: '3px solid #bf0a30',
                borderRadius: '15px',
                padding: '18px 30px',
                color: 'white',
                fontSize: '18px',
                fontWeight: 'bold',
                cursor: 'pointer',
                textTransform: 'uppercase',
                letterSpacing: '2px',
                boxShadow: '0 8px 25px rgba(0, 0, 0, 0.4)',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => e.target.style.transform = 'translateY(-2px)'}
              onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}
            >
              ★ DASHBOARD ADMIN ★
            </button>
          ) : user?.role === 'hotesse' ? (
            <button
              onClick={() => navigate('/hostess')}
              style={{
                background: 'linear-gradient(180deg, #1a1a1a 0%, #3d1c0f 50%, #1a1a1a 100%)',
                border: '3px solid #bf0a30',
                borderRadius: '15px',
                padding: '18px 30px',
                color: 'white',
                fontSize: '18px',
                fontWeight: 'bold',
                cursor: 'pointer',
                textTransform: 'uppercase',
                letterSpacing: '2px',
                boxShadow: '0 8px 25px rgba(0, 0, 0, 0.4)',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => e.target.style.transform = 'translateY(-2px)'}
              onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}
            >
              ★ INTERFACE HÔTESSE ★
            </button>
          ) : null}

          <button
            onClick={handleLogout}
            style={{
              background: 'linear-gradient(180deg, #bf0a30 0%, #8b0000 50%, #3d1c0f 100%)',
              border: '3px solid #1a1a1a',
              borderRadius: '15px',
              padding: '15px 30px',
              color: 'white',
              fontSize: '16px',
              fontWeight: 'bold',
              cursor: 'pointer',
              textTransform: 'uppercase',
              letterSpacing: '2px',
              boxShadow: '0 6px 20px rgba(0, 0, 0, 0.3)',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => e.target.style.transform = 'translateY(-2px)'}
            onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}
          >
            DÉCONNEXION
          </button>
        </div>

        {/* Footer */}
        <div style={{ marginTop: '40px', textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px' }}>
          <span style={{ fontSize: '20px', color: '#bf0a30' }}>★</span>
          <p style={{ color: '#3d1c0f', fontSize: '13px', margin: '0', fontWeight: 'bold' }}>
            © 2026 AMERICAN COLA.
          </p>
          <span style={{ fontSize: '20px', color: '#bf0a30' }}>★</span>
        </div>
      </div>
    </div>
  );
};

export default Home;
